@if (showHeaderValue) {
  <header class="qima-header">
    <div class="header-left">
      <div class="workspace-logo" (click)="onWorkspaceClick($event)" (keyup.enter)="onWorkspaceClick($event)">
        <img ngSrc="assets/icons/workspace.svg" alt="Workspace Logo" height="20" width="20" />
      </div>

      <qima-divider [qimaDividerOrientation]="eQimaDividerOrientation.VERTICAL"> </qima-divider>

      <div
        class="qima-logo"
        (click)="onLogoClick()"
        (keyup.enter)="onLogoClick()"
        tabindex="0"
        [attr.aria-label]="'HEADER.LOGO_ARIA_LABEL' | translate"
      >
        <img ngSrc="assets/qima-logo.svg" alt="QIMA Logo" height="20" width="90" />
      </div>

      @if (pageTitle()) {
        <span class="header-page-title" data-cy="header-page-title">{{ pageTitle() | translate }}</span>
      }
    </div>

    <div class="utilities">
      <div
        class="profile-menu"
        (click)="onProfileClick()"
        (keyup.enter)="onProfileClick()"
        tabindex="0"
        [attr.aria-label]="'HEADER.PROFILE_MENU' | translate"
      >
        <qima-avatar
          [qimaAvatarFirstName]="getCurrentUser()?.firstName"
          [qimaAvatarLastName]="getCurrentUser()?.lastName"
          [qimaAvatarSize]="eQimaAvatarSize.BASE"
          [qimaAvatarType]="eQimaAvatarType.ROUNDED"
          [qimaAvatarImage]="avatarUrl"
        >
        </qima-avatar>
        <div class="profile-menu-info">
          <span class="profile-menu-info-name">{{ getCurrentUser()?.firstName }} {{ getCurrentUser()?.lastName }}</span>
          <span class="profile-menu-info-email">{{ getSelectedRole() }}</span>
        </div>
        <qima-button-icon
          [qimaButtonIconName]="eQimaIconName.CHEVRON_DOWN"
          [qimaButtonIconSize]="eQimaButtonSize.SMALL"
          [qimaButtonIconStyle]="eQimaButtonIconStyle.SECONDARY"
          (qimaButtonIconClick)="onMenuClick($event)"
        ></qima-button-icon>
        @if (isMenuOpened) {
          <div #menuContainer class="dropdown-menu">
            @if (canSwitchRole) {
              <div
                class="dropdown-item"
                data-cy="header-switch-role"
                role="button"
                tabindex="0"
                [attr.aria-label]="'HEADER.SWITCH_ROLE' | translate"
                (click)="onSwitchRole()"
                (keydown.enter)="onSwitchRole()"
                (keydown.space)="$event.preventDefault(); onSwitchRole()"
              >
                <qima-icon [qimaIconName]="eQimaIconName.SWITCH" [qimaIconSize]="18"></qima-icon>
                <span>{{ 'HEADER.SWITCH_ROLE' | translate }}</span>
              </div>
            }
            <div class="dropdown-item" (click)="onLogout()" (keydown.enter)="onLogout()" (keydown.space)="onLogout()" tabindex="0">
              <qima-icon [qimaIconName]="eQimaIconName.LOGOUT" [qimaIconSize]="18"></qima-icon>
              <span>{{ 'HEADER.LOGOUT' | translate }}</span>
            </div>
          </div>
        }
      </div>

      <qima-divider [qimaDividerOrientation]="eQimaDividerOrientation.VERTICAL"> </qima-divider>

      <div class="language-dropdown">
        <qima-button-icon
          [qimaButtonIconStyle]="eQimaButtonIconStyle.TERTIARY_UTILITY"
          [qimaButtonIconName]="eQimaIconName.LANGUAGE_WORLD"
          [qimaButtonIconSize]="eQimaButtonSize.SMALL"
          [title]="currentLanguageFlag + ' ' + ('LANGUAGES.' + currentLanguageUpperCase | translate)"
          (qimaButtonIconClick)="onLanguageToggle()"
        >
        </qima-button-icon>

        @if (isShowLanguageDropdown) {
          <div class="language-options">
            @for (language of languages; track language.code) {
              <div
                id="language-{{ language.code }}"
                class="language-option"
                (click)="onLanguageChange(language.code)"
                (keyup.enter)="onLanguageChange(language.code)"
                (keyup.space)="onLanguageChange(language.code)"
                [class.active]="language.code === currentLanguage"
                [title]="language.name"
                tabindex="0"
                role="button"
                [attr.aria-label]="'Select ' + language.name + ' language'"
              >
                <span class="language-flag">{{ language.flag }}</span>
                <span class="language-name">{{ language.name }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </header>
}
